import React from 'react';

export type Steps = {
  title: string;
  child: React.ReactNode;
};

export type customStepperProps = React.PropsWithChildren<{
  currentStepIndex: number;
  steps: Steps[];
}>;

const Stepper = ({ currentStepIndex, steps }: customStepperProps) => {
  const stepsCount = steps.length;
  const currentStep = steps[currentStepIndex];

  return (
    <>
      <div className="custom-stepper d-flex">
        <div className="d-flex align-items-center">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`${index > currentStepIndex && 'd-none'}`}
            >
              <span
                className={`steps justify-content-center align-items-center ${
                  index === currentStepIndex
                    ? 'm-3 m-lg-3 d-flex selected'
                    : index > currentStepIndex
                    ? ''
                    : 'm-0 m-lg-3 d-none d-lg-flex completed'
                }`}
              >
                {index + 1}
              </span>
            </div>
          ))}
        </div>
        <div className="d-flex flex-column justify-content-center flex-grow-1 align-items-start">
          <div className="steps-count">
            {`step ${currentStepIndex + 1}/${stepsCount}`}
          </div>
          <div className="title mt-2">{currentStep.title}</div>
        </div>
        <div className="d-none d-lg-flex align-items-center">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`py-3 px-3 ${index <= currentStepIndex && 'd-none'}`}
            >
              <span className="steps d-flex justify-content-center align-items-center">
                {index + 1}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div>{currentStep.child}</div>
    </>
  );
};

export default Stepper;
